// Import package data to define it only one place
const pkg = require('../package.json');

module.exports = {
    version: pkg.version,
};
